"use client"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useState, useEffect } from 'react';
import ActionBlock from '../ActionBlock';

const FormatActionBlock = ({ actionBlockData } : any) => {

  const [blockBgColor, setBlockBgColor] = useState<string>('transparent');

  const formattedActionBlockTheme = actionBlockData?.theme === "Action Yellow" ? 't2-action-theme-one' : actionBlockData?.theme === "Action Black" ? 't2-action-theme-two' : actionBlockData?.theme === "Action White" ? 't2-action-theme-three' : 't2-action-theme-four';

  const formattedActionBlockForm = {
    ...actionBlockData?.form,
    formType: 'Marketo',
    description: actionBlockData?.form?.description && documentToReactComponents(actionBlockData?.form?.description.json),
    followUpMessage: actionBlockData?.form?.followUpMessage && documentToReactComponents(actionBlockData?.form?.description.json),
  }

  const displayMode = actionBlockData.displayType ? 'email' : 'buttons';
  let actionBlockButtons = actionBlockData?.buttonsCollection?.items?.map((button: any, i: Number) => {
    return {
      ...button,
      label: button?.textLabel || button?.label,
      destination: button?.url || button?.linkUrl,
      primary: button?.isPrimary,
      downloadName: button?.downloadName,
    }
  });

  if(displayMode === 'email') {
    actionBlockButtons = [
      { label: actionBlockData?.formFieldPlaceholder }
    ]
  }

  useEffect(() => {
    if(typeof window !== "undefined"){
      const containerClass = document.querySelector('.landing-page-container') 
      ? document.querySelector('.landing-page-container') 
      : document.querySelector('.layout-article--case-study')
      ? document.querySelector('.layout-article--case-study')
      : document.querySelector('.layout-article:not(layout-article--case-study)')
        ? document.querySelector('.layout-article:not(layout-article--case-study)')
        : null;
      const matchingElemClasses = containerClass?.lastElementChild?.querySelector('div[class*="t2-preset-theme-"]')?.classList;
      if(document?.querySelector('.landing-page-container') !== null) {
        matchingElemClasses?.forEach(className => {
          if(className.startsWith('t2-preset-theme-')) {
            setBlockBgColor(className);
          }
        })
      } else if (document.querySelector('.layout-article--case-study')) {
        setBlockBgColor('bg-mxpGray2');
      } else if (document.querySelector('.layout-article')){
        setBlockBgColor("bg-mxpGray2");
      }
    }
  },[setBlockBgColor])

  return (
    <div className={`t2-action-block-wrapper ${blockBgColor}`}>
      <div className="w-full relative">
        <div className="t2-action-block t2-action-block--sitewide t2-wrapper mx-auto p-0 m-0">
          <ActionBlock
            header={actionBlockData?.title}
            buttons={actionBlockButtons}
            headerIcon={actionBlockData?.headerIcon}
            presetTheme={formattedActionBlockTheme}
            formPlaceholder={actionBlockData?.formFieldPlaceholder}
            formData={formattedActionBlockForm}
            displayType={displayMode}
          />
        </div>
      </div>
    </div>
  )
}

export default FormatActionBlock;